/*
  src/redux/callAPI.js

  Editted by Justin Chang on May 18, 2017
*/
import axios from 'axios';
import Promise from 'bluebird';
import {UPDATE_LATENCY} from '../config';
import {SSO_TOKEN, SSO_URL, SLO_URL} from '../retailerValues';

// callSSO({
//   sessId:'<uuid>', // session identifier which Shoprite provided by calling our returnURL
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })(dispatch, getState)

export function callSSO(options) {
    const url = SSO_URL;
    console.log('SSO URL = ', url);
    return callSAML({...options, url: url});
}

// callSSO({
//   sessId:'<uuid>', // session identifier which Shoprite provided by calling our returnURL
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })(dispatch, getState)
export function callSLO(options) {
    const url = SLO_URL;
    return callSAML({...options, url: url});
}

function callSAML(options) {
    return (dispatch, getState) => {
        const token = SSO_TOKEN
        const baseUrl = options.url;
        const sessId = options.sessId;
        var urlParams = "";
        if (sessId)
            urlParams = "/sessId/" + sessId;
        urlParams += "?returnUrl=" + options.returnUrl;
        urlParams += "&Authorization=" + token;

        const url = baseUrl + urlParams;
        console.debug('calling SAML url ' + url);
        // Dispatch Begin
        if (options.begin) {
            dispatch({
                type: options.begin.type,
                payload: options.begin.payload()
            });
        }

        // Create Headers
        const headers = {
            // 'Content-Type': 'application/json; charset=UTF-8',
            // 'Accept': 'application/json',
            // 'Authorization': `${token}`
        };
        const instance = axios.create();

        instance.interceptors.response.use((response) => {
            return response
        }, (error) => {
            console.log("error occured in axious ", error);
            if (error.config.url === url) {
                let redirectUrl = "";
                if (sessId) {
                    redirectUrl = `https://wfcapi.azurewebsites.net/SRSSO/GetUserInfo?sessId=${sessId}&returnUrl=${options.returnUrl}`
                } else {
                    redirectUrl = "https://wfcapi.azurewebsites.net/SRSSO/Login" + urlParams;
                }
                console.log("redirectUrl = " + redirectUrl);
                return instance.get(redirectUrl)
            } else {
                return Promise.reject(error)
            }
        });

        return instance.request({
            // transformRequest: [data => JSON.stringify(data)],
            url: url,
            method: options.method || 'GET', // default to GET
            headers: options.headers || headers,
            data: (options.body) ? JSON.stringify(options.body) : null,
        })

        // Make API Call
        // return axios({
        //   // transformRequest: [data => JSON.stringify(data)],
        //   url: url,
        //   method: options.method || 'GET', // default to GET
        //   headers: options.headers || headers,
        //   data: (options.body) ? JSON.stringify(options.body) : null,
        // })

        // Handle 404 error
            .then(res => {
                console.log('SAML url ' + url + ' returned the following resukts ', res);
                return (res.data || {})
            })

            // Optional - Delay results
            .then((result) => {
                return new Promise((resolve) => {
                    if (!options.method || options.method === 'GET' || options.skipTimeout) {
                        resolve(result);
                    } else {
                        window.setTimeout(() => {
                            resolve(result);
                        }, UPDATE_LATENCY);
                    }
                });
            })

            //Check for 404 if necessary
            .catch(err => {
                console.log('SAML url ' + url + ' returned the following error ', err);

                if (err.response && err.response.status === 404 && options.allow404)
                    return err.response;
                else
                    throw err;
            })

            // Perform Success Action
            .then((res) => {
                // Dispatch Success
                console.log('SAML RESULTS = ', res);
                if (options.success) {
                    dispatch({
                        type: options.success.type,
                        payload: (options.success.payload) ? options.success.payload(res) : res
                    });
                    // Callbacks
                    if (options.success.result) {
                        return options.success.result(res);
                    }
                }
                return res;
            })

            // Perform Failure Action
            .catch((err) => {
                if (options.failure) {
                    dispatch({
                        type: options.failure.type,
                        payload: err,
                        error: true
                    });
                }

                throw err;
            });
    };
}



// WEBPACK FOOTER //
// ./src/redux/callSAML.js